import { Component, OnInit } from '@angular/core';
import { ISurveyDetails } from '../../core/models';
import { AdminService } from '../../core/services/admin.service';
import { AppNotifyService } from '../../core/services/app-notify.service';
import { UserService } from '../../core/services/user.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit {
  //#region member & variable declaration
  survey: ISurveyDetails[];
  comments: string = "";
  lblText: any = {
    submitedInfo1: "Submitted Successfully",
    continueShoppingLbl: "Continue Shopping!"
  }
  lblsurvey: any = {
    submitedInfo1: "Submitted Successfully",
    continueShoppingLbl: "Continue Shopping!"
  }
  surveyDialog: any = {
    opened: false
  }
  //#endregion
  constructor(private adminService: AdminService, private userService: UserService, private appNotifyService: AppNotifyService) { }
  radioArray: any;
  ngOnInit() {
    this.loadSurveyDetails();
  }
  loadSurveyDetails() {
    const body = {
      languageCode: localStorage.getItem("language")
    }
    this.adminService.getSurveyDetails(body).subscribe(response => {
      var tempResponse = response as ISurveyDetails[];
      if (tempResponse) {
        for (var i = 0; i < response.length; i++) {
          this.radioArray = [
            //add for loop here
            { id: 1 + i, label: "1", isSelected: false, name: "radio_" + i, checked: "" },
            { id: 2 + i, label: "2", isSelected: false, name: "radio_" + i, checked: "" },
            { id: 3 + i, label: "3", isSelected: false, name: "radio_" + i, checked: "" },
            { id: 4 + i, label: "4", isSelected: false, name: "radio_" + i, checked: "" },
            { id: 5 + i, label: "5", isSelected: false, name: "radio_" + i, checked: "" }
          ]
          response[i].surveyRating = this.radioArray;
        }
      }
      this.survey = response as ISurveyDetails[];
    })
  }
  onSelectionChange(list, row) {
    for (var i = 0; i < list.surveyRating.length; i++) {
      if (list.surveyRating[i].id === row.id) {
        list.surveyRating[i].isSelected = true;
      } else {
        list.surveyRating[i].isSelected = false;
      }
    }

  }
  resetForm() {
    this.comments = "";
    this.loadSurveyDetails();
  }
  //#region save survey details
  saveSurveyRatings() {
    var isSelected = false;
    if (this.survey.length > 0) {
      for (var i = 0; i < this.survey.length; i++) {
        const rowIndex = this.survey[i].surveyRating.findIndex(r => r.isSelected == true);
        if (rowIndex > -1) {
          this.survey[i].rating = this.survey[i].surveyRating[rowIndex].label;
          isSelected = true;
        }
      }
    }
    if (isSelected == false) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Please select atleast one!');
      return;
    }
    const body = {
      customerNumber: this.userService.readUserObject.customerNumber,
      surveyList: this.survey,
      comment: this.comments,
      customerName: this.userService.readUserObject.customerName,
      userName: this.userService.readUserObject.userFirstName + " " + this.userService.readUserObject.userLastName,
      userID: this.userService.readUserObject.userId,
      languageCode: localStorage.getItem('language'),
    }
    this.adminService.saveSurveyEntries(body).subscribe(response => {
      this.appNotifyService.notify(NotifyType.SUCCESS, 'Submitted successfully!');
      this.resetForm();
      this.surveyDialog.opened = true;

    })
  }
  //#endregion
}
